import React from 'react';
import CollectionCardItem from './CollectionCardItem';

const CollectionCardItems = ({
  category,
  items,
  onCheckBoxClick,
  single,
}) => (
  items.map((item, index) => (
    <CollectionCardItem
      category={category}
      collection={item}
      key={`collections_card_item_${item.code}`}
      onCheckBoxClick={onCheckBoxClick}
      single={single}
      upward={index > 4}
    />
  ))
);

export default CollectionCardItems;
